import React from 'react';
import { ContractorActivity } from '../../../types';
import { Formik } from 'formik';
import { Form, SubmitButton, Input, DatePicker, Select } from 'formik-antd';
import { Row, Col, Button } from 'antd';
import ContentWrapper from '../../../Components/ContentWrapper';
import { TimesheetStatus } from '../../../API';
import DictionnarySelect from './DictionnarySelect';
import { getAssignedByList, getTeamList } from '../../../utils/dictionnary';
import StatusSelect from './StatusSelect';

const validate = (values: ContractorActivity): any => {
  const errors = {} as any;
  // Trying to submit, check all entries
  if (!values.description) {
    errors.description = 'Please specify the task details';
  }
  return errors;
};

const ContractorActivityForm = ({
  record,
  save,
  close,
  deleteActivity,
}: {
  record: ContractorActivity | null;
  save: (data: ContractorActivity) => void;
  close: () => void;
  deleteActivity: () => Promise<void>;
}): React.ReactElement => {
  const isLocked = (!record?.timesheet && record?.id) || (record?.timesheet?.submitted && record?.timesheet.status !== TimesheetStatus.REJECTED);
  return (
    <div data-testid="activity-form">
      <ContentWrapper>
        <Formik initialValues={record || ({} as ContractorActivity)} onSubmit={save} validate={validate}>
          {(formProps: any): React.ReactElement => (
            <Form
              layout="vertical"
              // labelCol={{
              //   span: 6,
              // }}
              // wrapperCol={{
              //   span: 18,
              // }}
              // labelAlign="left"
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    name={`description`}
                    label="Task"
                    required
                    showValidateSuccess
                    showInitialErrorAfterTouched
                  >
                    <Input name="description" />
                  </Form.Item>
                  <Form.Item name={`assignedBy`} label="Assigned By">
                    <DictionnarySelect dictionnarySelector={getAssignedByList} name="assignedBy" />
                  </Form.Item>
                  <Form.Item name={`team`} label="Team">
                    <DictionnarySelect dictionnarySelector={getTeamList} name="team" />
                  </Form.Item>
                  <Form.Item name={`status`} label="Status">
                    <StatusSelect name="status" />
                  </Form.Item>
                  <Form.Item name={`startDate`} label="Start Date">
                    <DatePicker name="startDate" mode="date" />
                  </Form.Item>
                  <Form.Item name={`endDate`} label="Expected / Completion Date">
                    <DatePicker name="endDate" mode="date" />
                  </Form.Item>
                  <Form.Item name={`document`} label="Link to the document in the archiving folder">
                    <Input name="document" />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                    {!isLocked && (
                      <>
                        <SubmitButton style={{ marginRight: '10px' }}>Save</SubmitButton>
                      </>
                    )}
                    {!isLocked && record?.id !== 'new' && (
                      <Button type="primary" danger onClick={async (e) => {
                        e.preventDefault();
                        formProps.setSubmitting(true);
                        await deleteActivity();
                        formProps.setSubmitting(false);
                      }} disabled={formProps.isSubmitting}>
                        Delete
                      </Button>
                    )}
                    <Button type="default" onClick={close}>
                      Back
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ContentWrapper>
    </div>
  );
};

export default ContractorActivityForm;
